import { OtpErrorTypes } from '../typings';
import { BUSINESS_ERROR_CODES } from './status-and-error-codes';
export const INPUT_MISSING_DETAILS = 'missing input details';
export const PAGE_NAME = {
    ADDITION: 'addition',
    API_FAILURE: 'api failure',
    COMPLETE: 'complete',
    ERROR: 'error',
    IDENTITY_FAILURE: 'identity failure',
    INCORRECT_NAME: 'incorrect user name',
    LIMIT_REACHED: 'limit reached',
    NOT_ELIGIBLE_ADDRESS: 'not eligible address change',
    NOT_ELIGIBLE_FIRST_NAME: 'not eligible firstname change',
    SERVER_ERROR: 'server_error',
    START: 'start',
    USER_DECLINE: 'user decline'
};
export const SAMS_PAGE_NAME = {
    ADD_DOB: 'add dob sams',
    API_ERROR: 'api error sams',
    EXPIRED_MEMBERSHIP: 'membership expired sams',
    NO_ELIGIBLE_MEMBERS_FOUND: 'no eligible members sams',
    NOT_ELIGIBLE_MEMBERS: 'not eligible sams',
    NOT_VERIFIED: 'not verified sams',
    LIMIT_REACHED: 'max users sams',
    SELECTION: 'selection sams',
    START_VERIFIED: 'start sams verified',
    SUCCESS: 'success sams'
};
export const ANALYTICS_PAYLOAD = {
    [BUSINESS_ERROR_CODES.ADDRESS]: {
        pageName: PAGE_NAME.NOT_ELIGIBLE_ADDRESS
    },
    [BUSINESS_ERROR_CODES.FIRST_NAME]: {
        pageName: PAGE_NAME.NOT_ELIGIBLE_FIRST_NAME
    },
    [BUSINESS_ERROR_CODES.PROFANITY]: {
        pageName: PAGE_NAME.INCORRECT_NAME
    },
    [OtpErrorTypes.USER_DECLINED]: {
        pageName: PAGE_NAME.IDENTITY_FAILURE,
        errorMessage: OtpErrorTypes.USER_DECLINED
    },
    [OtpErrorTypes.ACCESS_DENIED]: {
        pageName: PAGE_NAME.IDENTITY_FAILURE,
        errorMessage: OtpErrorTypes.ACCESS_DENIED
    },
    api_failure: {
        pageName: PAGE_NAME.API_FAILURE
    }
};
export const SAMS_ANALYTICS_PAYLOAD = {
    [BUSINESS_ERROR_CODES.EXPIRED_MEMBERSHIP]: {
        pageName: SAMS_PAGE_NAME.EXPIRED_MEMBERSHIP
    },
    [BUSINESS_ERROR_CODES.NO_ELIGIBLE_MEMBERS_FOUND]: {
        pageName: SAMS_PAGE_NAME.NO_ELIGIBLE_MEMBERS_FOUND
    },
    [BUSINESS_ERROR_CODES.NOT_ELIGIBLE_MEMBERS]: {
        pageName: SAMS_PAGE_NAME.NOT_ELIGIBLE_MEMBERS
    },
    [OtpErrorTypes.USER_DECLINED]: {
        pageName: PAGE_NAME.IDENTITY_FAILURE,
        errorMessage: OtpErrorTypes.USER_DECLINED
    },
    [OtpErrorTypes.ACCESS_DENIED]: {
        pageName: PAGE_NAME.IDENTITY_FAILURE,
        errorMessage: OtpErrorTypes.ACCESS_DENIED
    },
    api_error: {
        pageName: SAMS_PAGE_NAME.API_ERROR
    }
};
